import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App, configureApi } from '@/app';
import './app/styles/index.scss';
import { ensureTelegramSdk, installTelegramMock } from '@/shared/lib/telegram';

/**
 * Старт отложен ровно на один случай: SDK Telegram не приехал.
 *
 * У кого он есть — а это подавляющее большинство — `ensureTelegramSdk`
 * возвращается немедленно, и порядок остаётся прежним. Ждём только тех,
 * кому основной источник недоступен: им копия догружается с нашего
 * домена, иначе приложение сказало бы «доступно только внутри Telegram»
 * игроку, который находится ровно внутри Telegram.
 *
 * Рендер после загрузки, а не параллельно: `installTelegramMock` и вход
 * читают `window.Telegram` сразу, и стартовать раньше значило бы
 * проверять то, чего ещё нет.
 */
async function bootstrap(): Promise<void> {
  const container = document.getElementById('root');
  if (!container) throw new Error('Не найден #root');

  await ensureTelegramSdk();

  installTelegramMock();
  configureApi();

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
